import { CheckBoxProps } from '@/constants/form/types';

/** 登録ガイドメッセージ */
export const authorityValidMessage = '';
export const authorityInvalidMessage = '登録権限を持たないユーザです';
export const registerFinishText = '登録が完了いたしました';

// 振替、仕入非表示時にトランなどに情報がない例外項目リスト
export const ExceptionHeaderItem = [
  'No',
  'copyButton',
  'deleteButton',
  'selectButtonIndex',
  'taxClassificationButton',
  'sale_price',
  'item',
  'model_number',
  'classification_id',
  'type_id',
  'item_code',
  'tax_classification'
];

// 構成明細のカラム
// TODO: 仕入関係は客先に確認中のため、コメントアウト
export const PartsListHeaders = [
  { text: 'No', value: 'No', width: '68' },
  { text: '品名', value: 'item', width: '170' },
  { text: '型番', value: 'model_number', width: '140' },
  { text: '標準単価', value: 'standard_unit_price', width: '130' },
  { text: '数量', value: 'quantity', width: '90' },
  { text: '販売金額', value: 'sale_price', width: '120' },
  { text: '課税区分選択', value: 'taxClassificationButton', width: '120' },
  { text: '課税区分', value: 'tax_classification', width: '120' },
  { text: '振替単価(参照用)', value: 'reference_transfer_unit_price', width: '148' },
  { text: '振替単価', value: 'transfer_unit_price', width: '130' },
  { text: '振替金額', value: 'transfer_amount_price', width: '120' },
  { text: '営業利益', value: 'operating_income', width: '98' },
  { text: '利益率', value: 'profit_rate', width: '86' },
  { text: '備考', value: 'remarks', width: '74', 'sortable': false },
  { text: '区分', value: 'classification_id', width: '80' },
  { text: '種別', value: 'type_id', width: '100' },
  { text: '品名コード', value: 'item_code', width: '200' }
];

//F-Japan用
export const PartsListHeadersFJapan = [
  { text: 'No', value: 'No', width: '68' },
  { text: '品名', value: 'item', width: '170' },
  { text: '型番', value: 'model_number', width: '140' },
  { text: '販売単価', value: 'standard_unit_price', width: '130' },
  { text: '数量', value: 'quantity', width: '90' },
  { text: '販売金額', value: 'sale_price', width: '120' },
  { text: '課税区分選択', value: 'taxClassificationButton', width: '120' },
  { text: '課税区分', value: 'tax_classification', width: '120' },
  { text: '備考', value: 'remarks', width: '74', 'sortable': false },
  { text: '区分', value: 'classification_id', width: '80' },
  { text: '種別', value: 'type_id', width: '100' },
  { text: '品名コード', value: 'item_code', width: '200' }
];

// 明細追加入力一覧のカラム
export const DetailsAdditionalInputListHeaders = [
  { text: 'No', value: 'No', width: '68' },
  { text: 'コピー', value: 'copyButton', width: '50' },
  { text: '削除', value: 'deleteButton', width: '50' },
  { text: '検索', value: 'selectButtonIndex', width: '50' },
  { text: '品名', value: 'item', width: '170' },
  { text: '標準単価', value: 'standard_unit_price', width: '130' },
  { text: '数量', value: 'quantity', width: '90' },
  { text: '販売金額', value: 'sale_price', width: '120' },
  { text: '課税区分選択', value: 'taxClassificationButton', width: '120' },
  { text: '課税区分', value: 'tax_classification', width: '120' },
  { text: '仕入単価(参照用)', value: 'reference_purchase_unit_price', width: '148' },
  { text: '仕入単価', value: 'purchase_unit_price', width: '130' },
  { text: '仕入金額', value: 'purchasing_price', width: '120' },
  { text: '営業利益', value: 'operating_income', width: '98' },
  { text: '利益率', value: 'profit_rate', width: '86' },
  { text: '備考', value: 'remarks', width: '74', 'sortable': false },
  { text: '区分', value: 'classification_id', width: '80' },
  { text: '種別', value: 'type_id', width: '100' },
  { text: '品名コード', value: 'item_code', width: '200' }
];

// 見積表のカラム
export const EstimateInputDataColumns = [
  { text: 'No', value: 'No', width: '70' },
  { text: 'コピー', value: 'copyButton', width: '50' },
  { text: '削除', value: 'deleteButton', width: '50' },
  { text: '検索', value: 'selectButtonIndex', width: '50' },
  { text: '区分', value: 'classification_id', width: '76' },
  { text: '種別', value: 'type_id', width: '76' },
  { text: '項目', value: 'item', width: '200' },
  { text: '販売単価', value: 'unit_price', width: '130' },
  { text: '数量', value: 'quantity', width: '90' },
  { text: '販売金額', value: 'sale_price', width: '120' },
  { text: '課税区分選択', value: 'taxClassificationButton', width: '120' },
  { text: '課税区分', value: 'tax_classification', width: '120' },
  { text: '仕入単価(参照用)', value: 'reference_purchase_unit_price', width: '148' },
  { text: '仕入単価', value: 'purchase_unit_price', width: '130' },
  { text: '仕入金額', value: 'purchasing_price', width: '120' },
  // { text: '営業利益', value: 'operating_income', width: '98' },
  // { text: '利益率', value: 'profit_rate', width: '100' },
  { text: '備考', value: 'remarks', width: '74', 'sortable': false }
];

// 見積表内ボタンアイテム設定
export const EstimateListDisplayButtonItems = [
  {
    'alwaysDisplayed': false,
    'class': 'btn-normal',
    'name': "copyButton",
    'text': "コピー"
  },
  {
    'alwaysDisplayed': false,
    'class': 'btn-normal',
    'name': "deleteButton",
    'text': "削除"
  },
  {
    'alwaysDisplayed': false,
    'class': 'btn-normal',
    'name': "selectButtonIndex",
    'text': "検索"
  },
  {
    'alwaysDisplayed': false,
    'class': 'btn-normal',
    'name': "remarks",
    'text': "備考"
  },
  {
    'alwaysDisplayed': false,
    'class': 'btn-normal',
    'name': 'taxClassificationButton',
    'text': '課税区分',
    'disabled': false,
    'buttonCheckDisplayId': 'tax_classification_edit_flag'
  }
];

export const EstimateListDisplayButtonDisabledItems = [
  {
    'alwaysDisplayed': false,
    'class': 'btn-normal',
    'name': "copyButton",
    'text': "コピー",
    'disabled': true
  },
  {
    'alwaysDisplayed': false,
    'class': 'btn-normal',
    'name': "deleteButton",
    'text': "削除",
    'disabled': true
  },
  {
    'alwaysDisplayed': false,
    'class': 'btn-normal',
    'name': "selectButtonIndex",
    'text': "検索",
    'disabled': true
  },
  {
    'alwaysDisplayed': false,
    'class': 'btn-normal',
    'name': "remarks",
    'text': "備考",
    'disabled': false,
  },
  {
    'alwaysDisplayed': false,
    'class': 'btn-normal',
    'name': 'taxClassificationButton',
    'text': '課税区分',
    'disabled': true,
    'buttonCheckDisplayId': 'tax_classification_edit_flag'
  }
];

// 見積表、明細追加入力一覧内マスタ参照での大項目検索設定(同じdisplay_id)
export const EstimateTableSearchLargeItemData: any = {
  findItemName: 'classification_id',
  setItemValue: 'classification_id',
  setItemText: 'classification_id'
};

// 見積表、明細追加入力一覧内マスタ参照での小項目検索設定(同じdisplay_id)
export const EstimateTableSearchSmallItemData: any = {
  findItemName: 'type_id',
  setItemValue: 'type_id',
  setItemText: 'type_id'
};

// 構成表、見積表、明細追加入力一覧内マスタ参照での課税区分大項目検索設定(同じdisplay_id)
export const EstimateTableTaxClassificationSearchLargeItemData: any = {
  findItemName: 'name',
  setItemValue: 'name',
  setItemText: 'name'
};

// 構成表、見積表、明細追加入力一覧内マスタ参照での課税区分小項目検索設定(同じdisplay_id)
export const EstimateTableTaxClassificationSearchSmallItemData: any = {
  findItemName: 'tax_rate',
  setItemValue: 'tax_rate',
  setItemText: 'tax_rate'
};

// eslint-disable-next-line @typescript-eslint/no-namespace
namespace EstimateListDisplayInputFormatItem {
  // 一覧表示内の入力項目内で使用するフォーマット設定
  export const Quantity = {
    'name': "quantity",
    'type': "number",
    'rules': ['between_quantity', 'quantity_step_value', 'max_limit_quantity', 'min_limit_quantity'],
    'min': 0,
    'max': 9999999999,
    'hideDetails': 'auto',
    'inputCheckFlag': true,
    'inputCheckName': 'edit_material_flag'
  };
  export const SalePrice = {
    'name': "sale_price",
    'type': "number",
    'rules': ['between_price'],
    'min': -9999999999,
    'max': 9999999999,
    'hideDetails': 'auto'
  };
  export const InputItems = {
    'name': "item",
    'type': "text",
    'inputCheckFlag': true,
    'inputCheckName': 'input_flag',
    'hideDetails': 'auto',
    'rules': []
  };
  export const ProductName = {
    'name': "item",
    'type': "text",
    'inputCheckFlag': true,
    'inputCheckName': 'input_flag',
    'hideDetails': 'auto',
    'rules': []
  };
  export const UnitPrice = {
    'name': "unit_price",
    'type': "number",
    'rules': ['between_price'],
    'hideDetails': 'auto',
    'min': -9999999999,
    'max': 9999999999,
    'inputCheckFlag': true,
    'inputCheckName': 'edit_material_flag'
  };
  export const PurchaseUnitPrice = {
    'name': "purchase_unit_price",
    'type': "number",
    'rules': ['between_price'],
    'hideDetails': 'auto',
    'min': -9999999999,
    'max': 9999999999,
    'inputCheckFlag': true,
    'inputCheckName': 'edit_material_flag'
  };
  export const TransferUnitPrice = {
    'name': "transfer_unit_price",
    'type': "number",
    'rules': ['between_price'],
    'hideDetails': 'auto',
    'min': -9999999999,
    'max': 9999999999,
    'inputCheckFlag': true,
    'inputCheckName': 'edit_material_flag'
  };
  export const StandardUnitPrice = {
    'name': "standard_unit_price",
    'type': "number",
    'rules': ['between_price', 'max_limit_price', 'min_limit_price'],
    'hideDetails': 'auto',
    'min': -9999999999,
    'max': 9999999999,
    'inputCheckFlag': true,
    'inputCheckName': 'edit_material_flag',
    'inputCheckNamePrice': 'edit_price_flag'
  };
}
export const EstimateListDisplayInputFormatItems = EstimateListDisplayInputFormatItem;

export const EstimateListDisplayInputFormatItemsPartsList = [
  EstimateListDisplayInputFormatItems.Quantity,
  EstimateListDisplayInputFormatItems.StandardUnitPrice,
  EstimateListDisplayInputFormatItems.TransferUnitPrice
];

export const EstimateListDisplayInputFormatItemsDetailAddList = [
  EstimateListDisplayInputFormatItems.ProductName,
  EstimateListDisplayInputFormatItems.StandardUnitPrice,
  EstimateListDisplayInputFormatItems.Quantity,
  EstimateListDisplayInputFormatItems.PurchaseUnitPrice
];

export const EstimateListDisplayInputFormatItemsEstimateDetailList = [
  EstimateListDisplayInputFormatItems.ProductName,
  EstimateListDisplayInputFormatItems.Quantity,
  EstimateListDisplayInputFormatItems.PurchaseUnitPrice
];

// eslint-disable-next-line @typescript-eslint/no-namespace
namespace EstimateCommodityMasterData {
  // 見積表内マスタ参照で表示するカラム設定
  export const Columns = [
    { text: 'サービス種別', value: 'service_type_id', width: '80' },
    { text: '商材', value: 'commodity', width: '100' },
    { text: '商材仕入先', value: 'supplier_id', width: '100' }
  ];
}
export const EstimateCommodityMasterDatas = EstimateCommodityMasterData;

// eslint-disable-next-line @typescript-eslint/no-namespace
namespace EstimateMasterData {
  // 商材マスタのカラム
  export const CommodityColumns = [
    { text: 'サービス種別', value: 'service_type_id', width: '80' },
    { text: '商材', value: 'commodity', width: '100' },
    { text: '商材仕入先', value: 'supplier_id', width: '100' }
  ];

  // 明細追加入力マスタのカラム
  export const DatailAddInputColumns = [
    { text: '品名コード', value: 'item_code', width: '80' },
    { text: '品名', value: 'item', width: '80' },
    { text: '標準単価', value: 'standard_unit_price', width: '80' },
    { text: '仕入単価', value: 'purchase_unit_price', width: '80' },
    { text: '区分', value: 'classification_id', width: '80' },
    { text: '種別', value: 'type_id', width: '80' },
    { text: '備考', value: 'remarks', width: '80' }
  ];

  // 見積明細マスタのカラム
  export const DatailColumns = [
    { text: '区分', value: 'classification_id', width: '80' },
    { text: '種別', value: 'type_id', width: '80' },
    { text: '項目', value: 'item', width: '80' },
    { text: '販売単価', value: 'unit_price', width: '80' },
    { text: '仕入単価', value: 'purchase_unit_price', width: '80' },
    { text: '備考', value: 'remarks', width: '80' }
  ];

  // 料率マスタのカラム
  export const masterRateColumns = [
    { value: 'leasing_company_id', text: 'リース会社名', width: '20%' },
    { value: 'contract_months_calculation_disp', text: '契約月数', width: '20%' },
    { value: 'money_min', text: '金額（下限）', width: '20%' },
    { value: 'money_max', text: '金額（上限）', width: '20%' },
    { value: 'rate', text: '料率', width: '20%' }
  ];

  // 課税区分マスタのカラム
  export const masterTaxColumns = [
    { value: 'name', text: '名称', width: '20%' },
    { value: 'tax_rate', text: '税率', width: '20%' },
    { value: 'application_start_date', text: '適用開始日', width: '20%' },
    { value: 'application_end_date', text: '適用終了日', width: '20%' }
  ];
}
export const EstimateMasterDatas = EstimateMasterData;

export const EstimateDatailAddInputBaseFormat = {
  'No': 1,
  'copyButton': 0,
  'deleteButton': 0,
  'selectButtonIndex': 0,
  'id': 0,
  'delete_flag': 0,
  'estimate_id': '',
  'item_code': '',
  'item': '',
  'standard_unit_price': 0,
  'quantity': 0,
  'reference_purchase_unit_price' : 0,
  'purchase_unit_price': 0,
  'classification_id': '',
  'classification': '',
  'type_id': '',
  'type': '',
  'remarks': '',
  // 明細追加入力トランにない項目(計算などで使用)
  'sale_price': 0,
  'purchasing_price': 0,
  'operating_income': 0,
  'profit_rate': '0%',
  'input_flag': false
};

export const EstimateDatailBaseFormat = {
  'No': 1,
  'copyButton': 0,
  'deleteButton': 0,
  'selectButtonIndex': 0,
  'id': 0,
  'delete_flag': 0,
  'estimate_id': '',
  'item_code': '',
  'item': '',
  'unit_price': 0,
  'quantity': 0,
  'reference_purchase_unit_price' : 0,
  'purchase_unit_price': 0,
  'classification_id': '',
  'classification': '',
  'type_id': '',
  'type': '',
  'remarks': '',
  // 見積明細トランにない項目(計算などで使用)
  'sale_price': 0,
  'purchasing_price': 0,
  'operating_income': 0,
  'profit_rate': '0%',
  'input_flag': false
};

// 見積アクションで見積情報を削除するアクションID
export const EstimateDeleteActionId = [
  'estimate_basic_info_OA_temporarily_saved_delete',
  'estimate_basic_info_OA_registering_delete',
  'estimate_basic_info_general_temporarily_saved_delete',
  'estimate_basic_info_general_registering_delete'
]

export const EstimateMonthlyLeaseFeeWording = {
  // 月額リース料に端数が発生した場合、登録時にワーニング表示する文言
  execDialog: {
    message: '月額リース料に端数が発生しています。登録を続けますか？',
    title: '登録確認'
  }
};

export const EstimateFixedMatterWording = {
  // 確定見積ボタンを押下した場合に表示する文言
  fixedMatterDialog: {
    title: '',
    buttonTextOK: '採用する'
  }
};

// 端数調整に係るダイアログ文言
export const EstimateFractionRoundWording = {
  // 見積確定ボタンを押下した場合に表示するアラート文言
  alertFixedMatter: {
    message: '端数調整を実施していない見積を確定見積に設定することはできません。',
    title: '見積確定'
  },
  // 端数調整ボタンを押下した際、端数が存在しない場合に表示するアラート文言
  alertFractionNotRequired: {
    message: '端数が存在しないため、端数調整は不要です。',
    title: '端数調整'
  },
  // 金額調整ボタンを押下した場合に表示する実行確認文言
  confirmRecalc: {
    message: '入力された料率で金額調整を実施します。よろしいですか？',
    title: '金額調整'
  },
  // 金額調整の結果、増額明細となった場合に表示するアラート文言
  alertRecalcIncreasedAmount: {
    message: '増額の金額調整を実施しました。\n必要に応じて項目名を編集してください。',
    title: '金額調整'
  },
  // 金額調整の結果、値引き額が増加した場合に表示するアラート文言
  alertRecalcIncreasedDiscount: {
    message: '値引き増の金額調整を実施しました。\n必要に応じて項目名を編集してください。',
    title: '金額調整'
  },
  // 金額調整の結果、割引き額が減少した場合に表示するアラート文言
  alertRecalcDecreaseDiscount: {
    message: '値引き減の金額調整を実施しました。\n必要に応じて項目名を編集してください。',
    title: '金額調整'
  },
  // 金額調整時の再計算で調整金額が変わらなかった場合に表示するアラート文言
  alertRecalcNoChange: {
    message: '調整金額に変更はありませんでした。',
    title: '金額調整'
  },
  // 「料率変更する」で料率変更後に金額調整を実施していない場合に表示するアラート文言
  alertNoRecalc: {
    message: '料率を変更した場合は必ず金額調整を行ってください。',
    title: '登録'
  },
  // 「料率変更する」で料率変更後に金額調整を実施していない場合に表示するアラート文言
  alertOverAddItems: {
    message:
      'これ以上明細を追加することはできません。\n明細追加一覧に登録されているいずれかの商材を削除してから、\n改めて明細追加をおこなってください。',
    title: ''
  }
};

// 事前与信チェックに係るダイアログ文言
export const EstimateCreditCheckWording = {
  alertCreditCheck: {
    message: '月額リース料が事前与信で承認された金額を超えています。\nこのまま登録を続けますか？',
    title: '事前与信チェック'
  }
};

// 構成表内の数量がゼロの行を表示・非表示のチェックボックス内容
export const ZeroVisibleCheckBoxsData: Array<CheckBoxProps> = [
  {
    name: 'zero_visible',
    text: '数量がゼロの行を非表示',
    default: false,
    addClass: 'checkbox-fontsize'
  }
];

export const TemplateWarningMessage = '表示中の構成表と選択されたテンプレートの部品構成が一致しません。別のテンプレートを使用するか、対象のテンプレートを修正してください。';
